import * as Sentry from '@sentry/react';
// @mui
import { Button, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

/**
 * Sits above the route tree so a render error contains here instead of unmounting the app to a
 * blank page. A failed lazy chunk is the common cause: `React.lazy` stores the rejection and
 * rethrows it on every later render, which `Suspense` does not catch. `chunkReload.ts` reloads on
 * a failed preload, and this is what the user sees when that reload is on cooldown or the error
 * came from somewhere else.
 */
export default function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ height: 1, p: 5 }}>
          <Typography variant="h4">Something went wrong</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Reloading the page usually clears this.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Stack>
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
